import type { ReactNode } from 'react';
import { Stack, SxProps } from '@ltvco/refresh-lib/theme';
import { MessagesContainerStack } from '@ltvco/refresh-lib/v2';
import { useScreenSize } from '@ltvco/refresh-lib/utils';

interface IFeaturePageShellProps {
  header: ReactNode;
  children: ReactNode;
  chatInput?: ReactNode;
  feedbackModal?: ReactNode;
  wrapperSx?: SxProps;
  messagesContainerSx?: SxProps;
}

export const FeaturePageShell = ({
  header,
  children,
  chatInput,
  feedbackModal,
  wrapperSx = {},
  messagesContainerSx = {},
}: IFeaturePageShellProps) => {
  const { isMobile } = useScreenSize();

  return (
    <Stack
      direction="column"
      width="100%"
      height="100%"
      sx={{
        ...wrapperSx,
      }}
    >
      <MessagesContainerStack
        spacing={2}
        sx={{
          width: '100%',
          height: '100%',
          position: 'relative',
          ...messagesContainerSx,
        }}
      >
        {header}
        {children}
        {!isMobile && chatInput}
      </MessagesContainerStack>
      {feedbackModal}
    </Stack>
  );
};
